import constants from '../constants';
import getIconDialogCommonTraits from '../helpers/get-icon-dialog-common-traits';
import trackEvent from './track-event';

const { events } = constants;

export default function trackSelectIconIconError({
  dialogId,
  targetElementId,
  iconId,
  isAnimated,
  isFree,
  tabId,
  premiumAvailable,
}) {
  const traits = {
    dialogId,
    iconId,
    isAnimated,
    isFree,
    tabId,
    premiumAvailable,
    ...getIconDialogCommonTraits(targetElementId),
  };

  trackEvent(events.SELECT_ICON_ICON_ERROR, traits);
}
